<template>
  <div>
    <v-text-field
      @click="open(null)"
      append-icon="mdi-magnify"
      v-bind="$attrs"
      :value="localDeEstoqueNome"
    ></v-text-field>

    <DialogoFormulario
      ref="dialog"
      title="Local de estoque"
      :width="500"
      :handler="handler"
    >
      <template v-slot="{ form, errors }">
        <v-radio-group v-model="form.local" row>
          <v-radio label="Cliente" value="cliente"></v-radio>
          <v-radio label="Loja" value="brastop"></v-radio>
        </v-radio-group>

        <div v-if="form.local === 'cliente'">
          <CampoSeletorCliente
            v-model="form.cliente"
            label="Cliente"
            outlined
          />

          <CampoSeletorEndereco
            v-model="form.endereco"
            label="Endereço"
            outlined
            :cliente-id="form.cliente ? form.cliente.id : null"
          ></CampoSeletorEndereco>
        </div>
      </template>
    </DialogoFormulario>
  </div>
</template>

<script>
import DialogoFormulario from "@/components/dialogos/DialogoFormulario.vue";
import CampoSeletorCliente from "@/components/clientes/CampoSeletorCliente.vue";
import CampoSeletorEndereco from "@/components/clientes/CampoSeletorEndereco.vue";
import api from "@/services/locacoes";

export default {
  mixins: [],

  components: {
    DialogoFormulario,
    CampoSeletorCliente,
    CampoSeletorEndereco
  },

  props: {
    value: Object
  },

  model: {
    prop: "value",
    event: "update:value"
  },

  data() {
    return {};
  },

  methods: {
    open(inicial) {
      this.$refs.dialog.open({
        local: "cliente"
      });
    },

    async handler(form) {
      const localDeEstoque = await api.locais_de_estoque.buscarOuCriar({
        cliente_id: form.cliente.id,
        endereco_id: form.endereco.id
      });

      this.$emit("update:value", localDeEstoque);
    }
  },

  computed: {
    localDeEstoqueNome() {
      if (!this.value) {
        return "";
      }

      return this.value.nome;
    }
  }
};
</script>
